module.exports = __webpack_public_path__ + "img/img0306.a58ebaa4.png";